import { createClient } from "@sanity/client";
import { makeSafeQueryRunner } from "groqd";

let dataset = process.env.SANITY_DATASET;
dataset ??= process.env.NODE_ENV === "development" ? "development" : "production";

const sanityClient = createClient({
    projectId: "1a2df6ej", // you can find this in sanity.json
    dataset, // or the name you chose in step 1
    useCdn: false, // `false` if you want to ensure fresh data
    apiVersion: "2021-10-21", // use a UTC date string
    token: process.env.SANITY_TOKEN // or leave blank for unauthenticated usage
});

export default sanityClient;

export const runQuery = makeSafeQueryRunner(
    (query, params: Record<string, unknown> = {}) => sanityClient.fetch(query, params)
);
